import { Injectable } from '@angular/core';
import { filter as lodashFilter, differenceWith, isEqual, cloneDeep, remove } from 'lodash';
import { IdataBinding } from '@ispm-client/modules/aggregator/interfaces';


@Injectable()
export  class DataBindingHandlerService {

       findDepandants(dataBindings: IdataBinding[]) {
         return lodashFilter(dataBindings, function(o) {
           return  (o.hasOwnProperty('isDepandant') && (o.isDepandant === true)); });
       }

       pickerIdentifierPath(dataBindings: IdataBinding[]) {
         return lodashFilter(dataBindings, function(o) { return o.hasOwnProperty('pickerIdentifierPath'); });
       }

       findDependantsExcludingPickerIdentifierPath(dataBindings: IdataBinding[]) {
            const dependants = this.findDepandants(dataBindings);
            const pickerIdentiferPath = this.pickerIdentifierPath(dataBindings);
            return differenceWith(dependants, pickerIdentiferPath, isEqual);
       }

        findPreFetch(dataBindings: IdataBinding[]) {
         const prefetch = lodashFilter(dataBindings, function(o) { return ((o.prefetch === true) || (!o.hasOwnProperty('prefetch'))); });
         const dependants = this.findDepandants(dataBindings);
         return differenceWith(prefetch, dependants, isEqual);
        }

}
